import { useEffect } from "react";
import Navbar from "../components/Navbar";
import SeccionRetail from "../components/Retail/SeccionRetail";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";

export function Retail() {
  const { t } = useTranslation();
  const pathByLang = t("seo.retail.pathByLang", { returnObjects: true });

  useEffect(() => {
    localStorage.setItem("colorFooter", "white");
    localStorage.setItem("colorNav", "color");
  }, []);

  return (
    <div>
      <Seo pageKey="retail" pathByLang={pathByLang} />
      <Navbar />
      <SeccionRetail />
    </div>
  );
}
